export const daasBG = require("./daasBGnoLogo.png");
export const daasDevices = require("./daas_overlay-fs8.png");
export const daasImage1 = require("./daas_why.png");
export const daasImage2 = require("./daas_projects.png");
export const daasImage3 = require("./daas_upgrades.png");
